














import { Component, Vue } from 'vue-property-decorator';
import Navbar from '@/components/Navbar.vue';
import Dropup from '@/components/Dropup.vue';
import { User, Organisation } from '@/models/User';
import { mapGetters } from 'vuex';

@Component({
    components: {
        navbar: Navbar,
        dropup: Dropup,
    },
    computed: mapGetters({
        account: 'account/account',
        organisation: 'organisation/organisation',
        isOwner: 'organisation/isOwner',
    }),
})
export default class App extends Vue {
    error: string = '';
    account!: User;
    organisation!: Organisation;

    async created() {
        const account = await this.$store.dispatch('account/init');

        if (!account) {
            if (this.$router.currentRoute.path !== '/') {
                this.$router.push('/');
            }
            return;
        } else {
            await this.$store.dispatch('organisation/init', account);
            const users = await this.$store.dispatch('users/init');

            // Todo move this to forms route
            await this.$store.dispatch('formLabels/init');
            await this.$store.dispatch('forms/init', users);
        }
    }
}
